import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ConnectionState } from 'livekit-client'
import type { Room } from 'livekit-client'

import { SpinnerIcon } from '@/src/assets/icons'
import { useConnectionState } from '@/src/hooks'
import { Toast } from './Toast'

/** @public */
export interface ConnectionStateToastProps extends React.HTMLAttributes<HTMLDivElement> {
  room?: Room
}

/**
 * The `ConnectionStateToast` component displays a toast
 * notification indicating the current connection state of the room.
 * @public
 */
export function ConnectionStateToast(props: ConnectionStateToastProps) {
  const [notification, setNotification] = useState<React.ReactElement | null>(null)
  const state = useConnectionState(props.room)
  const { t } = useTranslation()

  useEffect(() => {
    switch (state) {
      case ConnectionState.Reconnecting:
        setNotification(
          <>
            <SpinnerIcon className="lk-spinner" /> {t('reconnecting')}
          </>,
        )
        break
      case ConnectionState.Connecting:
        setNotification(
          <>
            <SpinnerIcon className="lk-spinner" /> {t('connecting')}
          </>,
        )
        break
      case ConnectionState.Disconnected:
        setNotification(<>{t('disconnecting')}...</>)
        break
      default:
        setNotification(null)
        break
    }
  }, [state, t])

  return notification && <Toast className="lk-toast-connection-state">{notification}</Toast>
}
